/**
 * @file 集合了针对数字进行精读处理的utils
 */
import { formatNumber } from '@web3/base-utils';
import BigNumber from 'bignumber.js';

/**
 * 针对收益的展示
 */
export const formatYield = (num: string) => {
  if (
    BigNumber(num || 0).lte('0.00009') &&
    BigNumber(num || 0).gte('0.00001')
  ) {
    return '0.0001';
  }
  return BigNumber(num || 0).toFixed(4);
};

/**
 * 给数字加上千分位
 *  */
export const groupShowNumber = (n: number, maximumFractionDigits = 3) =>
  new Intl.NumberFormat(undefined, { maximumFractionDigits }).format(n);

/**
 * 格式化金额，如果小数点后超过4位则展示<0.0001
 *  */
export const formatUSDYield = (num: string, decimal?: number) => {
  if (BigNumber(num || 0).eq('0')) {
    return '=$0.00';
  }
  if (BigNumber(num || 0).lt('0.0001')) {
    return '<$0.0001';
  }
  return `≈ $${BigNumber(BigNumber(num).toFixed(decimal ?? 4)).toFixed()}`;
};

/**
 * 保留小数点后的有效位数2位，针对小数点后0比较多比较长的情况，比如0.000000123123123 => 0.00000012
 */
export const formatPrecision = (num: string) => {
  if (BigNumber(num || 0).lt('0.0001')) {
    return BigNumber(num).precision(2).toString();
  }

  return BigNumber(num).toFixed(4);
};

//  检查有效数字小数点是否超过8位
export const checkDecimal = (value: string) => {
  if (value.length === 0) return true;
  const reg = /^[0-9]+(\.[0-9]{0,8})?$/;
  return reg.test(value);
};

export const formatUSD = (num: string, decimal?: number) => {
  if (BigNumber(num || 0).eq('0')) {
    return '=$0.00';
  }
  if (BigNumber(num || 0).lt('0.0001')) {
    return '<$0.0001';
  }
  return `≈ $${formatNumber(num, {
    kmb: true,
    decimal,
    smallNumberUseValidDigits: false,
    collapseZero: false,
  })}`;
};
